import { request } from "../../base/HTTP";
import HttpMethod from "../../constants/HttpMethod";

export async function generateExportData(data) {
  return await request('/api/exportData/', data, HttpMethod.GET, { responseType: 'blob' });
}

export async function getGksResExists(){
  return await request('/api/exportData/existsgksres', [], HttpMethod.GET);
}

export async function getGksResData(data){
  return await request('/api/exportData/getgksres', data, HttpMethod.GET, { responseType: 'blob' });
}

/** Point 22: all deceased for the public web presentation, as .xlsx. Slow — about two minutes. */
export async function generateWebPresentationExport(data) {
  return await request('/api/exportData/webPresentation', data, HttpMethod.GET, { responseType: 'blob' });
}
